export default function PHP_insteadof() {
  return (
    <div>
      <h1>PHP_insteadof</h1>
    </div>
  );
}
